import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import { addMonopattiniQuoteToCart, monopattiniQuotesGetQuotes, removeMonopattiniQuoteFromCart } from '../../features/insuranceRequests/insuranceRequestsActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import { MonopattiniQuotesStyles, RiskContainer } from './styles/MonopattiniResultPage.styles';
import MonopattiniModalButtons from './components/MonopattiniModalButtons';
import MonopattiniModal from './components/MonopattiniModal';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import MonopattiniSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/MonopattiniSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

function MonopattiniResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    // toSelect,
    quote_id_to_add,
  } = useSelector((store) => store.insuranceRequests.monopattini);

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  // const [showModal, setShowModal] = useState(false);
  const refresh = () => monopattiniQuotesGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/monopattini-elettrici', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addMonopattiniQuoteToCart(
      quoteId,
      refresh,
      modifyData,
      closeButton,
      quote_id_to_add,
    ));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeMonopattiniQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    monopattiniQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/monopattini-elettrici/purchase/${requestToken}`);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      <V2FontImport />
      <MonopattiniQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <MonopattiniSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>
          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id]
                        && (processingQuote === null || type.id === 'res_civile' || quotations[type.id].some((q) => q.code === processingQuote.code))
                        && (
                          <MonopattiniModalButtons
                            insuranceRequest={insuranceRequest}
                            processingQuote={processingQuote}
                            type={type}
                            removeItemFromCart={removeItemFromCart}
                            riskQuotations={riskQuotations}
                          />
                        )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <MonopattiniModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>
      </MonopattiniQuotesStyles>
    </>
  );
}

export default MonopattiniResultPage;
